import React from 'react'
import Styled from 'styled-components'
import { connect } from 'react-redux'

import {
  setProjectDevice
} from 'actions/project'

import Icon from 'components/Icon'

const Controls = Styled.div`
  position: absolute;
  top: 50%;
  left: 1rem;
  z-index: 1;
  transform: translate3d(0, -50%, 0);
`

const Control = Styled.div`
  position: relative;
  color: ${props => props.theme.colors.gray.shade100};
  transition: 300ms;
  cursor: pointer;
  width: 2.5rem;
  height: 2.5rem;

  &:hover {
    color: ${props => props.theme.colors.gray.shade200};
  }

  ${props => props.active && `
    color: ${props.theme.colors.gray.shade700};

    &:hover {
      color: ${props.theme.colors.gray.shade700};
    }
  `}

  i {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    font-size: 1.5rem;
  }
`

const DeviceControls = ({ device, onChange }) => (
  <Controls>
    <Control
      active={device === 'desktop'}
      onClick={() => onChange('desktop')}
    >
      <Icon liga="laptop_mac" />
    </Control>

    <Control
      active={device === 'tablet'}
      onClick={() => onChange('tablet')}
    >
      <Icon liga="tablet_mac" />
    </Control>

    <Control
      active={device === 'mobile'}
      onClick={() => onChange('mobile')}
    >
      <Icon liga="phone_iphone" />
    </Control>

  </Controls>
)

const mapDispatchToProps = (dispatch) => {
  return {
    onChange: device => dispatch(setProjectDevice(device))
  }
}

const mapStateToProps = (state) => {
  return {
    device: state.project.device
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceControls)



// WEBPACK FOOTER //
// ./src/components/DeviceControls/index.js